<form [formGroup]="setupForm">
  <div class="setup-intro">
    <p>
      Use this tile to combine a text message, action buttons, and supporting icons. Configure the
      main message first, then tailor the icon buttons and background styling.
    </p>
  </div>

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Text</h2>
    </div>
    <div class="editor-section__content">
      <p class="section-intro">This editor controls the main presentation copy shown in the tile.</p>
      <lib-text-editor
        [compactColorPicker]="true"
        [formGroup]="setupForm"
        textFormControlName="text"
        fontColorFormControlName="textFontColor"
        fontSizeFormControlName="textFontSize"
      ></lib-text-editor>
    </div>
  </section>
  <hr class="editor-divider" />

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Background</h2>
    </div>
    <div class="editor-section__content">
      <p class="section-intro">Sets the shared background behind the presentation content.</p>
      <mat-form-field appearance="fill">
        <mat-label>Background</mat-label>
        <input matInput formControlName="background" />
        <mat-hint>Defines the background image or asset used for the tile.</mat-hint>
      </mat-form-field>
    </div>
  </section>
  <hr class="editor-divider" />

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Icons</h2>
    </div>

    <div class="editor-section__content">
      <p class="section-intro">Add icon buttons and define how each one should look.</p>
      <div
        *ngFor="let icon of setupForm.controls.icons.controls; let i = index"
        [formGroup]="icon"
        class="array-entry"
      >
        <div class="array-entry-header">
          <h3>Icon {{ i + 1 }}</h3>
          <button mat-icon-button (click)="removeIcon(i)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Icon</mat-label>
          <input matInput formControlName="icon" />
          <mat-hint>Sets the icon shown for this button.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Icon Style</mat-label>
          <mat-select formControlName="iconStyle">
            <mat-option value="basic">Basic</mat-option>
            <mat-option value="outline">Outline</mat-option>
          </mat-select>
          <mat-hint>Chooses whether the icon uses a filled or outlined treatment.</mat-hint>
        </mat-form-field>

        <div class="color-fields">
          <lib-color-picker-square
            [formGroup]="icon"
            controlName="iconColor"
            [inputId]="'presentation-icon-color-' + i"
            label="Icon Colour"
            hint="Sets the primary color of the icon."
          ></lib-color-picker-square>

          <lib-color-picker-square
            [formGroup]="icon"
            controlName="iconOutlineColor"
            [inputId]="'presentation-icon-outline-color-' + i"
            label="Icon Outline Colour"
            hint="Sets the outline color when the outlined style is used."
          ></lib-color-picker-square>

          <lib-color-picker-square
            [formGroup]="icon"
            controlName="iconBackgroundColor"
            [inputId]="'presentation-icon-background-color-' + i"
            label="Icon Background Colour"
            hint="Sets the background color behind the icon."
          ></lib-color-picker-square>
        </div>
      </div>

      <div style="text-align: center">
        <button mat-flat-button color="primary" (click)="addIcon()">Add Icon</button>
      </div>
    </div>
  </section>
  <hr class="editor-divider" />

  <section class="editor-section">
    <div class="editor-section__header">
      <h2>Buttons</h2>
    </div>

    <div class="editor-section__content">
      <p class="section-intro">Add optional links or calls to action shown below the text.</p>
      <lib-links-editor
        [compactColorPicker]="true"
        [linksFormArray]="setupForm.controls.linkButtons"
        [outlinedEntries]="true"
        [roomyFields]="true"
        [tileInstance]="tileInstance"
      ></lib-links-editor>
    </div>
  </section>
</form>

<div class="footer" style="bottom:-20px">
  <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
</div>
